import { DataExchangeRequestDto } from '../data-transfer/entities/data-exchange-request-entities/data-exchange-request-dto';
import { DataExchangeRequestStatusDto } from '../data-transfer/entities/data-exchange-request-entities/data-exchange-request-status-dto';
import { DeadlineStateDisplay, getEffectiveDeadlineDisplay, getDeadlineOutcomeDisplay } from './deadline-state-badge-map';

export interface DataExchangeRequestRowState extends DeadlineStateDisplay {
  canEditDeadline: boolean;
  canApprove: boolean;
  submission: DeadlineStateDisplay;
  closing: DeadlineStateDisplay;
}

export type DataExchangeRequestRow = DataExchangeRequestDto & DataExchangeRequestRowState;

export function applyRowState(row: DataExchangeRequestDto, isReceived: boolean): DataExchangeRequestRow {
  const isOpen = row.status !== DataExchangeRequestStatusDto.Closed && row.status !== DataExchangeRequestStatusDto.Deleted;

  return Object.assign(row, {
    ...getEffectiveDeadlineDisplay(row.status, row.deadlineState, row.closingState),
    submission: getDeadlineOutcomeDisplay(row.submissionState, 'submissionState'),
    closing: getDeadlineOutcomeDisplay(row.closingState, 'closingState'),
    canEditDeadline: !isReceived && isOpen,
    canApprove: row.status === DataExchangeRequestStatusDto.Submitted,
  });
}
